import { useState, useEffect } from "react";
import "./style.css";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import AlertMessage from "../../../components/Alert";
import { Load } from "../../../components/Load";
import AsoHeader from "../../../components/Aso/Header";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import InputMask from 'react-input-mask';

const InformacoesTrabalhadorAso = () => {
    const [employeeData, setEmployeeData] = useState<any>({});
    const [error, setError]: any = useState('');
    const [items, setItems] = useState<any>([]);
    const [DbName, setDbName] = useState<any>('');
    const [showEmployeeCard, setShowEmployeeCard] = useState(true);
    const [sortOrder, setSortOrder] = useState('asc'); // Estado para controlar a ordem de classificação

    useEffect(() => {
        const idConsulta = localStorage.getItem('consulta');
        const cpf = localStorage.getItem('cpf');
        const dbName = localStorage.getItem('dbName');
        setDbName(dbName);

        const handleSearchEmployee = async () => {
            try {
                const response = await api.post(`validar-trabalhador/${idConsulta}/${dbName}`);
                if (response.data && typeof response.data === 'object') {
                    setEmployeeData(response.data);
                } else {
                    setError("Funcionário não encontrado.");
                }
            } catch (error) {
                console.log(error);
                setError("Ocorreu um erro ao buscar os dados do funcionário.");
            }
        };

        handleSearchEmployee();
    }, []);

    const handleListDocuments = async () => {
        try {
            const encodedName = encodeURIComponent(employeeData.nome);
            const response = await api.get(`listas-asos/${encodedName}/${DbName}`);
            setItems(response.data);
            console.log("🚀 ~ handleListDocuments ~ response:", response.data)
            setShowEmployeeCard(false);
        } catch (error) {
            console.log(error);
        }
    };

    // Função para alternar a ordem da classificação
    const toggleSortOrder = () => {
        const newOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(newOrder);
        setItems([...items].sort((a, b) => newOrder === 'asc' ? a.idConsulta - b.idConsulta : b.idConsulta - a.idConsulta));
    };

    return (
        <>
            <AsoHeader />
            <div className='aso-container-inf'>
                {showEmployeeCard ? (
                    <>
                        <div className='aso-title-inf'>
                            Quer acessar seus documentos assinados? Por favor, confirme suas informações e insira um email e senha válidos para acessar nosso sistema com segurança.
                        </div>
                        <div className='aso-card-inf'>
                            <Form>
                                <Form.Group>
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={employeeData.nome || ''}
                                        readOnly />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>CPF</Form.Label>
                                    <InputMask
                                        mask="999.999.999-99"
                                        type="text"
                                        className='form-control'
                                        value={employeeData.cpf || ''}
                                        readOnly />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>RG</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={employeeData.rg || ''}
                                        readOnly />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Data de Nascimento</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={employeeData.dt_nas}
                                        readOnly />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Sexo</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={
                                            employeeData.sexo === 'f' ? 'Feminino' :
                                                employeeData.sexo === 'm' ? 'Masculino' : ''
                                        }
                                        readOnly
                                    />
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='aso-button-container-inf'>
                            <Button
                                variant="primary"
                                className='aso-button-inf'
                                onClick={handleListDocuments}>
                                Continuar
                            </Button>
                        </div>
                    </>
                ) : (
                    <div className='aso-title-inf'>
                        Documentos Assinados (ASO) - {employeeData.nome}
                    </div>
                )}

                {error && (
                    <div className="error-container text-danger">
                        <p className="error-text text-center">{error}</p>
                    </div>
                )}

                {showEmployeeCard === false && (
                    items.length > 0 ? (
                        <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                            <div style={{ maxHeight: '300px', overflowY: 'auto' }}> {/* Limita a altura da tabela e adiciona barra de rolagem */}
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>
                                                Consulta
                                                <button onClick={toggleSortOrder} style={{ marginLeft: '10px', background: 'none', border: 'none', color: 'white' }}>
                                                    {sortOrder === 'asc' ? '↑' : '↓'}
                                                </button>
                                            </th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Funcionário</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Clínica</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item: any, index: any) => (
                                            <tr key={index} style={{ textAlign: 'center' }}>
                                                <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                    {item.idConsulta}
                                                </td>
                                                <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                    {item.nomeEmpresa}
                                                </td>
                                                <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                    {item.cliente}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : (
                        <Col className="d-flex justify-content-center" style={{ marginTop: '20px' }}>
                            <Row>
                                <Alert variant="danger" className="text-center">Nenhum documento ASO encontrado!</Alert>
                            </Row>
                        </Col>
                    )
                )}
            </div>
        </>
    );
};

export default InformacoesTrabalhadorAso;
